import {
	Button,
	Col,
	Form,
	InputNumber,
	Row,
	Select,
	notification,
	Typography,
	Space,
} from "antd";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
const { Title } = Typography;

const AddPlantEfficiency = ({ pcb }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(true);
	const [optionsPlant, setOptionsPlant] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getPlants();
	}, []);

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			data.payload.map((item) => {
				list.push({
					value: item._id,
					label: item.name,
				});
			});
			setOptionsPlant(list);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const createPlantEfficiency = async (datas) => {
		try {
			setLoading(true);

			if (!datas.plants) {
				openNotification("warning", "Warning", "You must fill the plants");
				setLoading(false);
				return;
			}

			const formData = {
				plants: datas.plants,
				createdBy: localStorage.getItem("userId"),
			};

			let url = api + "/plantefficiency/create";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, formData);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					setLoading(false);
					pcb();
				}, 1000);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to create plant efficiency"
			);
			console.error(err.message);
			return null;
		}
	};

	const onChange = (value) => {
		const plants = form.getFieldValue("plants");
		let options = optionsPlant;
		let index = optionsPlant.findIndex((obj) => obj.value === value);
		options[index].disabled = true;
		options.map((item) => {
			if (plants.find((o) => o.plant === item.value)) {
				item.disabled = true;
			} else {
				item.disabled = false;
			}
		});
		setOptionsPlant(options);
	};

	const round2 = (value) => Number(Number(value).toFixed(2));

	const updateProductionDailyCost = (index) => {
		const plants = form.getFieldValue("plants");
		const current = plants[index];

		const dailyCY = current?.productionDailyCY || 0;
		const cost = current?.productionCost || 0;

		const newValue = round2(dailyCY * cost);

		form.setFieldValue(["plants", index, "productionDailyCost"], newValue);
	};

	const updateProductionMin = (index) => {
		const plants = form.getFieldValue("plants");
		const current = plants[index];

		const productionMoCY = current?.productionMoCY || 0;

		const dailyCY = round2(productionMoCY / 26);

		form.setFieldValue(["plants", index, "productionDailyCY"], dailyCY);

		const cost = current?.productionCost || 0;

		const dailyCost = round2(dailyCY * cost);
		form.setFieldValue(["plants", index, "productionDailyCost"], dailyCost);
	};

	const onChangeValue2 = (value, index) => {
		updateProductionDailyCost(index);
	};

	const onChangeValue3 = (value, index) => {
		updateProductionMin(index);
	};

	const onRemoveItem = (removeFunction, name) => {
		let plants = form.getFieldValue("plants");
		if (plants[name] === undefined) {
			removeFunction(name);
		} else if (!plants[name].plant) {
			removeFunction(name);
		} else {
			let plant = plants.at(name).plant;
			let options = optionsPlant;
			let index = optionsPlant.findIndex((obj) => obj.value === plant);
			options[index].disabled = false;
			setOptionsPlant(options);
			removeFunction(name);
		}
	};

	const onFinish = (values) => {
		createPlantEfficiency(values);
	};

	const CustomForm = () => {
		return (
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Row gutter={16}>
					<Col span={24}>
						<Title level={3}>Plants</Title>
					</Col>
					<Col span={24}>
						<Form.List name="plants">
							{(fields, { add, remove }) => (
								<>
									{fields.map(({ key, name, ...restField }) => (
										<Space
											key={key}
											style={{
												display: "flex",
												marginBottom: 8,
											}}
											align="baseline"
										>
											<Form.Item
												{...restField}
												name={[name, "plant"]}
												label="Plant"
												rules={[
													{
														required: true,
														message: "Missing plant item",
													},
												]}
											>
												<Select
													style={{
														width: "100%",
													}}
													size="large"
													placeholder="Please select plant"
													options={optionsPlant}
													onChange={(e) => onChange(e, name)}
												/>
											</Form.Item>
											<Form.Item
												{...restField}
												name={[name, "productionDailyCY"]}
												label="Minimum Daily Production [CY]"
												rules={[
													{
														required: true,
														message: "Missing quantity",
													},
												]}
											>
												<InputNumber
													size="large"
													style={{ width: "100%" }}
													formatter={(value) =>
														`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
													}
													parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
													disabled
												/>
											</Form.Item>
											<Form.Item
												{...restField}
												name={[name, "productionMoCY"]}
												label="Production/MO [CY]"
												rules={[
													{
														required: true,
														message: "Missing quantity",
													},
												]}
											>
												<InputNumber
													size="large"
													style={{ width: "100%" }}
													formatter={(value) =>
														`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
													}
													parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
													onChange={(value) => onChangeValue3(value, name)}
												/>
											</Form.Item>
											<Form.Item
												{...restField}
												name={[name, "productionCost"]}
												label="Production Cost"
												rules={[
													{
														required: true,
														message: "Missing quantity",
													},
												]}
											>
												<InputNumber
													size="large"
													style={{ width: "100%" }}
													formatter={(value) =>
														`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
													}
													parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
													onChange={(value) => onChangeValue2(value, name)}
												/>
											</Form.Item>
											<Form.Item
												{...restField}
												name={[name, "productionDailyCost"]}
												label="Daily Min Production Cost"
												rules={[
													{
														required: true,
														message: "Missing quantity",
													},
												]}
											>
												<InputNumber
													size="large"
													style={{ width: "100%" }}
													formatter={(value) =>
														`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
													}
													parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
													disabled
												/>
											</Form.Item>
											<MinusCircleOutlined
												onClick={() => {
													onRemoveItem(remove, name);
												}}
											/>
										</Space>
									))}
									<Form.Item>
										<Button
											type="dashed"
											onClick={() => add()}
											block
											icon={<PlusOutlined />}
										>
											Add Plant
										</Button>
									</Form.Item>
								</>
							)}
						</Form.List>
					</Col>
				</Row>

				<Button type="primary" htmlType="submit" loading={loading}>
					Create
				</Button>
			</Form>
		);
	};

	return (
		<div>
			{contextHolder}
			<CustomForm />
		</div>
	);
};

export default AddPlantEfficiency;
